import React from 'react';
import Serializer, {
  type SerializeArguments,
  type DeserializeArguments,
} from './Serializer';
import { isParagraphElement } from '../../types/guards';

// Convert a paragraph to span for inline shared snippets.
class SerializerInlineParagraph extends Serializer {
  static deserialize(params: DeserializeArguments): undefined {}

  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!isParagraphElement(node)) return;

    return <span>{children}</span>;
  }
}

export default SerializerInlineParagraph;
